import { isValidURL } from './utils.url';

export function findClosestDealer(dealers) {
  if (dealers.length < 2) {
    return dealers;
  }
  let clostestIndex = 0;
  for (let i = 0; i < dealers.length; i++) {
    const cur = dealers[i];
    if (cur['dealerInfo'].distance < dealers[clostestIndex]['dealerInfo'].distance) {
      clostestIndex = i;
    }
  }
  return dealers.map((item, idx) => ({
    ...item,
    dealerInfo: { ...item.dealerInfo, isClosest: clostestIndex === idx },
  }));
}

export function getDealerListVehicleImageURL(vehicleImageURL: string) {
  return isValidURL(vehicleImageURL) ? vehicleImageURL : `//s3.amazonaws.com/icoassets.awskbbico.kbb.com${vehicleImageURL}`;
}
